import { Component, ElementRef, Input, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'nc-scroll-list',
  templateUrl: './scroll-list.component.html',
  styleUrls: ['./scroll-list.component.less']
})
export class ScrollListComponent implements AfterViewInit, OnDestroy {
  /** 滚动时间，多少秒滚动一行 */
  @Input() ncTime: number = 1;//多少秒滚动一格
  /** 移入暂停 */
  private _pause: boolean = false;
  @Input() set ncPause(value: boolean | string) {
    this._pause = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncPause(): boolean {
    return this._pause;
  }

  private observer!: MutationObserver;
  private mouseenterHandler?: () => void;
  private mouseleaveHandler?: () => void;

  constructor(private eleRef: ElementRef, private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.initializeScrollList();
    this.setupMutationObserver();
  }

  private initializeScrollList(): void {
    const scoll: HTMLElement = this.eleRef.nativeElement.querySelector('.scroll');

    // 清空现有内容
    while (scoll.childNodes.length > 1) {
      scoll.removeChild(scoll.lastChild!);
    }

    // 克隆并添加新内容
    const clone = scoll.firstElementChild?.cloneNode(true);
    if (clone) {
      scoll.appendChild(clone);
    }

    const scollList: Array<HTMLElement> = this.eleRef.nativeElement.querySelectorAll('.scroll-list');
    let eleCount = scollList[0].childElementCount;

    // 重置动画
    scollList.forEach(element => {
      element.style.animation = 'none';
      element.offsetHeight; // 触发重排
      element.style.animation = `scroll calc(${this.ncTime} * ${eleCount} * 1s) linear infinite`;
    });

    if (this.ncPause) {
      // 移除旧的事件监听器
      if (this.mouseenterHandler) {
        scoll.removeEventListener('mouseenter', this.mouseenterHandler);
      }
      if (this.mouseleaveHandler) {
        scoll.removeEventListener('mouseleave', this.mouseleaveHandler);
      }

      // 创建新的事件处理函数
      this.mouseenterHandler = () => {
        scollList[0].style.animationPlayState = 'paused';
        scollList[1].style.animationPlayState = 'paused';
      };
      this.mouseleaveHandler = () => {
        scollList[0].style.animationPlayState = 'running';
        scollList[1].style.animationPlayState = 'running';
      };

      // 添加新的事件监听器
      scoll.addEventListener('mouseenter', this.mouseenterHandler);
      scoll.addEventListener('mouseleave', this.mouseleaveHandler);
      //mouseleave：仅在鼠标指针离开被选元素时触发，不会因为鼠标移动到任何子元素上而触发；不会向上冒泡到父元素。
      //mouseout：会在鼠标指针离开被选元素或其任何子元素时触发；会冒泡到父元素，如果父元素上绑定了mouseout事件监听器，那么鼠标在子元素上移动也可能触发该监听器。
    }

    this.cdr.detectChanges();
  }

  private setupMutationObserver(): void {
    const list: HTMLElement = this.eleRef.nativeElement.querySelector('#scroll-container');
    if (!list) return;

    this.observer = new MutationObserver(() => {
      // console.log('数据发生变化');
      this.initializeScrollList();
    });

    this.observer.observe(list, {
      // childList: true,//该项开启后非常卡顿，initializeCarousel会一直执行
      subtree: true,
      characterData: true
    });
  }

  ngOnDestroy(): void {
    // 在组件销毁时清理事件监听器
    const scoll: HTMLElement = this.eleRef.nativeElement.querySelector('.scroll');
    if (scoll) {
      if (this.mouseenterHandler) {
        scoll.removeEventListener('mouseenter', this.mouseenterHandler);
      }
      if (this.mouseleaveHandler) {
        scoll.removeEventListener('mouseleave', this.mouseleaveHandler);
      }
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
